

import * as api from "../../../../api"; 


  
export const createNewSection = (APIData) => async (dispatch)=>{
    try {
        const {data } = await api.createNewSection(APIData);
        // console.log(data)
        if(data){ return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
        
        
     } catch (error) {
       
    }
}


export const getAllSectionsByMilestoneId = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api.getAllSectionsByMilestoneId(APIData);
    
      if(data){  return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
   } catch (error) {
     
  }
}




export const reArrangeSections = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api.reArrangeSections(APIData);
    
      if(data){  return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
   } catch (error) {
     
  }
}